import { Form } from "react-bootstrap";
const renderColorOptions = ({
  images,
  type,
  outLineChange,
  captureSnapshot,
  name,
}) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(52px, 1fr))",
      gap: "10px 6px",
    }}
  >
    {images.map((image, idx) => {
      let background;
      if (Array.isArray(image.color) && image.color.length === 2) {
        background = `linear-gradient(90deg, ${image.color[0]} 50%, ${image.color[1]} 50%)`;
      } else if (Array.isArray(image.color) && image.color.length > 2) {
        background = `linear-gradient(90deg, ${image.color.join(", ")})`;
      } else {
        background = Array.isArray(image.color) ? image.color[0] : image.color;
      }
      const title = image?.image
        ?.split("/")
        ?.at(-1)
        ?.split("_")?.[0]
        ?.split(" ")
        ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        ?.join(" ");

      return (
        <div key={idx} className="thread-color-item">
          <div
            className="thread-color-option"
            style={{ background }}
            onClick={() => {
              outLineChange(image, type, name);
              setTimeout(() => captureSnapshot?.(), 100);
            }}
          />
          <span className="thread-color-name text-capitalize">
            {title}
          </span>
        </div>
      );
    })}
  </div>
);
export const ThreadColorTabContent = ({
  art1Thread,
  art2Thread,
  outLineChange,
  captureSnapshot,
}) => {
  console.log(art2Thread);

  return (
    <div
      style={{
        backgroundColor: "#E8E9ED",
        borderRadius: "10px",
        maxHeight:"870px",
        overflowY:"auto"
      }}
      className="p-3"
    >
      <Form.Label
        style={{
          fontSize: "20px",
          fontWeight: "500",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        Thread Color
      </Form.Label>

      {/* Art 1 Thread Colors */}
      {art1Thread && art1Thread.images && art1Thread.images.length > 0 && (
        <div className="mb-4">
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              marginBottom: "10px",
            }}
          >
            Design
          </div>
          {renderColorOptions({
            images: art1Thread.images,
            type: "art1",
            captureSnapshot,
            outLineChange,
            name: art1Thread.name,
          })}
        </div>
      )}

      {/* Art 2 Thread Colors */}
      {art2Thread && art2Thread.length > 0 && (
        <div className="mb-4">
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              marginBottom: "10px",
            }}
          >
            Graphic Add-ons
          </div>
          {art2Thread?.map((art2) => (
            <>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  marginBottom: "10px",
                }}
              >
                {art2?.name}
              </div>
              {renderColorOptions({
                images: art2.images,
                type: "art2",
                captureSnapshot,
                outLineChange,
                name: art2.name,
              })}
            </>
          ))}
        </div>
      )}

      {(!art1Thread || !art1Thread.images || art1Thread.images.length === 0) &&
        (!art2Thread ||
          !art2Thread.images ||
          art2Thread.images.length === 0) && <div>No colors available</div>}
    </div>
  );
};
